import language from "./../../src/common/i18n/de_de.json";

const dictionary = language;

// If needed, you can add or override translations here for the current client
dictionary.notifications_title = "oops";
dictionary.Archive = "Ältere Ausgaben";
dictionary.notifications_title = "oops";
dictionary.home = "Kiosk";
dictionary.Promospot = "Beilagen";
dictionary.HorsSeries = "Extra";
dictionary.Archive = "Ältere Ausgaben";
dictionary.recently = "Ältere Ausgaben";
dictionary.regions = "Lokalausgaben";
dictionary.region = "Lokalausgaben";
dictionary.account = "Benutzerkonto";
dictionary.ReadingPreference = "Darstellung";
dictionary.readingModeToggle = "Darstellung";
dictionary.about = "Weitere Informationen";
dictionary.dataPolicy = "Impressum";
dictionary.privacyPolicy = "Datenschutzerklärung";
dictionary.cropPrintInstruction =
  "Um einen Teil einer Seite oder eines bestimmten Artikels zu drucken, passen Sie die Größe des blauen Rahmens an.";
dictionary.E5 =
  "Leider wurde kein gültiges Abo gefunden. Bitte wenden Sie sich gegebenenfalls an den Kundenservice.";
dictionary.alsoRead = "Link zum Werbetreibenden";
dictionary.Extra = "Noch mehr Inhalte";

export default dictionary;



// WEBPACK FOOTER //
// ./clients/swmh-kbb/dictionary.js